import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import VistasView from './VistasView';
import * as ROUTES from '../../../router/Routes';

const VistasModule = () => {
  return (
    <ContainerTemplate active={ROUTES.vistas} routes={[ROUTES.root]}>
      <VistasView />
    </ContainerTemplate>
  );
};

export default VistasModule;
